"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M12.509 21.03a4.917 4.917 0 0 0-4.194 1.2 12.924 12.924 0 0 0-2.68 4.782c-.463 1.94-.9 3.772-3.359 4.772a.6.6 0 0 0-.341.712.9.9 0 0 0 .644.658 23.76 23.76 0 0 0 1.977.4c2.608.41 7.48.738 10.807-1.651 1.237-.848 2.836-2.982 2.822-4.547a6.813 6.813 0 0 0-5.676-6.326zM19.9 24.1c7.235-8.227 16.422-19.535 14.016-21.941S21.546 10.976 14.38 18.83a10.051 10.051 0 0 1 5.52 5.27z" })
);

